import script from "./PositionsRecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionsRecordTable.vue?vue&type=script&setup=true&lang=js"

import "./PositionsRecordTable.vue?vue&type=style&index=0&id=3514880a&scoped=true&lang=scss"
script.__scopeId = "data-v-3514880a"

export default script